var map = {
	"./color1.png": 189,
	"./color10.png": 913,
	"./color2.png": 950,
	"./color3.png": 967,
	"./color4.png": 120,
	"./color5.png": 25,
	"./color6.png": 842,
	"./color7.png": 971,
	"./color8.png": 372,
	"./color9.png": 437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 331;